import RouteView from "../../../Routes/RouteView.js"; // Adjust path
import PaymentTermsNavOptions, {
	defaultRoute,
} from "./PaymentTermsNavOptions.js"; // New NavOptions
import React from "react";

const PaymentTerms = ({ navoption, ModalAction }) => {
	return (
		<RouteView
			navoption={navoption}
			ModalAction={ModalAction}
			defaultRoute={defaultRoute}
		>
			{PaymentTermsNavOptions}
		</RouteView>
	);
};

export default PaymentTerms;
